import { useEffect, useState } from "react";
import { SelectInput } from "../SelectInput";
import { addUserToCorporationOverview, addUserToCorporation, AddUserToCorporationOverviewResponse } from "../../api/tools";
import { Alert, AlertTypes } from "../Alert";
import { Modal } from "../Modal";
import { Table } from "../Table";
import { Button, ButtonTypes } from "../Button";
import TextInput, { InputTypes } from "../TextInput";
import { getAllCorporations } from "../../helpers/corporation";

export default function AddUserToCorporationForm() {
    const [userId, setUserId] = useState(0);
    const [corporationId, setCorporationId] = useState(0);
    const [allCorporations, setAllCorporations] = useState([]);
    const [roleId, setRoleId] = useState(11);
    const [errorResponse, setErrorResponse] = useState('');
    const [successReponse, setSuccessResponse] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [overview, setOverview] = useState({} as AddUserToCorporationOverviewResponse | null);

    useEffect(() => {
        getAllCorporations().then(corporations => {
            if (corporations) {
                setAllCorporations(corporations as any);
            }
        })
    }, [])

    async function handleSubmit(e: Event) {
        e.preventDefault();
        const overview = await addUserToCorporationOverview({ userId, corporationId, roleId });
        setOverview(overview);
        setShowModal(true);
    }

    async function submit(e: Event) {
        e.preventDefault();
        resetState();
        const response = await addUserToCorporation({ userId, corporationId, roleId });
        if (response?.exception) {
            setErrorResponse(response?.message);
        } else {
            setSuccessResponse(`User: ${userId} was successfully added to the corporation: ${corporationId}`);
        }
    }

    function resetState() {
        setErrorResponse('');
        setSuccessResponse('');
        setOverview(null);
        setShowModal(false);
    }

    function isFormValid() {
        return userId && corporationId && roleId;
    }

    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <div className="card mb-4 full-width">
                        <h5 className="card-header">Add user to corporation</h5>
                        <div className="card-body">
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <TextInput
                                        onValue={(value: number) => setUserId(value)}
                                        label="User ID"
                                        placeholder="1230"
                                        description="User to be added to the corporation"
                                        type={InputTypes.NUMBER}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <SelectInput
                                        label="Corporation"
                                        options={
                                            allCorporations
                                        }
                                        placeholder={
                                            {
                                                value: '',
                                                label: 'Select corporation'
                                            }
                                        }
                                        value={corporationId}
                                        onValue={(option: any) => setCorporationId(option.value)}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <SelectInput
                                        options={[
                                            {
                                                value: 11,
                                                label: 'Corporation owner'
                                            },
                                            {
                                                value: 14,
                                                label: 'Community manager'
                                            },
                                            {
                                                value: 8,
                                                label: 'Janitor'
                                            },
                                            {
                                                value: 12,
                                                label: 'Facility manager'
                                            }
                                        ]}
                                        placeholder={{
                                            value: 11,
                                            label: 'Corporation owner'
                                        }}
                                        label="User role"
                                        description="The role that the user is going to have in the corporation"
                                        value={roleId}
                                        onValue={(option: any) => setRoleId(option.value)}
                                    />
                                </div>
                            </div>
                            <div className="pt-4">
                                <Button type={ButtonTypes.PRIMARY} text="Add user" className={!isFormValid() ? 'disabled' : ''} onPress={(e: Event) => handleSubmit(e)} />
                            </div>
                            {errorResponse && (
                                <div className="pt-4">
                                    <Alert type={AlertTypes.DANGER} text={errorResponse} />
                                </div>
                            )}
                            {successReponse && (
                                <div className="pt-4">
                                    <Alert type={AlertTypes.SUCCESS} text={successReponse} />
                                </div>
                            )}
                            {showModal && (
                                <Modal
                                    title="Details about the action"
                                    onConfirm={(e: Event) => submit(e)}
                                    onCancel={(e: Event) => setShowModal(false)}
                                >
                                    {overview && (
                                        <>
                                            <Table
                                                cols={[
                                                    { name: 'User ID' },
                                                    { name: 'User name' },
                                                    { name: 'Corporation name' },
                                                    { name: 'Role' }
                                                ]}
                                                rows={[
                                                    {
                                                        cells: [
                                                            { content: `${overview?.user?.id}` },
                                                            { content: `${overview.user?.person?.first_name} ${overview.user?.person?.family_name}` },
                                                            { content: `${overview.corporation?.name}` },
                                                            { content: `${overview.role?.name}` }
                                                        ]
                                                    }
                                                ]}
                                            />
                                        </>
                                    )}
                                </Modal>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}